import type { ChangeEvent } from 'react';
import styles from './Games.module.css';

export type FileButtonProps = {
  label: string;
  onFiles: (files: File[]) => void;
  accept?: string;
  multiple?: boolean;
  disabled?: boolean;
};

/**
 * A button-looking label around a real file input, so the keyboard and screen readers get the
 * native control. The input is stretched over the label and made transparent.
 */
export function FileButton({ label, onFiles, accept, multiple, disabled }: FileButtonProps) {
  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    const files = Array.from(event.target.files ?? []);
    // Choosing the same file again must fire another change event.
    event.target.value = '';
    if (files.length > 0) onFiles(files);
  }

  return (
    <label className={[styles['fileButton'], disabled ? styles['fileDisabled'] : ''].join(' ')}>
      {label}
      <input
        type="file"
        className={styles['fileInput']}
        accept={accept}
        multiple={multiple}
        disabled={disabled}
        onChange={handleChange}
      />
    </label>
  );
}
